/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Component, Input, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-drag-and-drop-error',
    templateUrl: './drag-and-drop-error.component.html',
    styleUrls: ['./drag-and-drop-error.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DragAndDropErrorComponent {
    @Input() message: string;
}
